import dynamic from "next/dynamic";

const FloatingElements = dynamic(() => import("../home/floating-elements").then(mod => mod.FloatingElements), { ssr: false });

/**
 * Higher-Order Component that wraps a page component with home page layout features
 * @param {React.ComponentType} Component - The page component to wrap
 * @returns {React.ComponentType} - The wrapped component with home page layout
 */
const withHomeLayout = (Component) => {
  const WithHomeLayout = (props) => {
    return (
      <div className="relative min-h-screen max-w-screen overflow-hidden bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900">
        <FloatingElements />
        <div className="relative z-10">
          <Component {...props} />
        </div>
      </div>
    );
  };

  // Copy static methods and display name
  WithHomeLayout.displayName = `withHomeLayout(${
    Component.displayName || Component.name || "Component"
  })`;

  return WithHomeLayout;
};

export default withHomeLayout;
